import { render, staticRenderFns } from "./ChinaHeaders.vue?vue&type=template&id=2b3e81e0&lang=html"
import script from "./ChinaHeaders.vue?vue&type=script&lang=js"
export * from "./ChinaHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports